/**
 * How to tell a person the wait sent by the auth service as
 * `retry_after_minutes` (tendril-connect#2266): minutes up to two hours,
 * whole hours past that. `count` is ready for an i18next plural key.
 */
export function retryAfter (minutes: number): { unit: 'minutes' | 'hours'; count: number } {
  const whole = Math.max(1, Math.ceil(minutes));
  if (whole >= 120) {
    return { unit: 'hours', count: Math.ceil(whole / 60) };
  }
  return { unit: 'minutes', count: whole };
}
